import { AccessDevicesTitle, IconChipDepartment, IconCustomAccess } from "../../../../../../../components/buttons/IconButtons";
import React, { useState } from "react";
import AssignedTabResource from "../../../../../../../components/ResourceAssignment/SubComponents/AssignedTabResource";
import { TabPanelApp } from "../../../../../../../components/ResourceAssignment/Functionality/TabPanelApp";
import { SHIFT_RESOURCE } from "../Model/Models";
import { AssignedShiftResourceApp } from "../Functionality/AssignedShiftResourceApp";
import AssignedSectionTitle from "../../../../../../../components/CustomAvailableAssignedItems/SubComponents/AssignedSectionTitle";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */

/**
 * Read-only assigned list for one shift resource (devices / departments /
 * users) inside the list detail expand. Owns its own tab state and renders the
 * server assigned page through AssignedTabResource in readOnly mode (no
 * checkbox, no deletion).
 *
 * @param {Object} props
 * @param {string} props.resource - SHIFT_RESOURCE type.
 * @param {number|string} props.id - Shift id.
 * @returns {JSX.Element}
 */
const RenderAssignedSection = ({ resource, id, title, Icon }) => {
    const [selected, setSelected] = useState([]);
    const [selectForDelete, setSelectForDelete] = useState([]);

    const {
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        triggerDelete, setTriggerDelete,
        isAllChecked, setIsAllChecked,
    } = TabPanelApp();


    return (
        <AssignedTabResource
            useAssignedApp={AssignedShiftResourceApp}
            readOnly={true}
            resource={resource}
            id={id}
            selected={selected}
            setSelected={setSelected}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            triggerDelete={triggerDelete}
            setTriggerDelete={setTriggerDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            results={results}
            setResults={setResults}
            setBodyForExport={setBodyForExport}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            renderModuleTitle={<AssignedSectionTitle Icon={Icon} title={title} />}
        />
    );
};

/**
 * Expanded row detail for a shift access list entry. Renders the shift's
 * assigned devices, departments and custom access (employees) as read-only
 * paginated lists, reusing AssignedTabResource (the same component used in
 * the create/update flow).
 *
 * @param {Object} props
 * @param {Object} props.row - Shift list row ({ id }).
 * @returns {JSX.Element}
 */
const RenderDetails = ({ row }) => {
    return (
        <div className='shift-detail-lists'>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.DEVICES} id={row.id} title={'assigned_devices'} Icon={AccessDevicesTitle}/>
            </div>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.DEPARTMENTS} id={row.id} title={'assigned_departments'} Icon={IconChipDepartment}/>
            </div>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={SHIFT_RESOURCE.USERS} id={row.id} title={'assigned_employees'} Icon={IconCustomAccess}/>
            </div>
        </div>
    );
}

export default RenderDetails;
